import Slider from "@material-ui/core/Slider";
import Custom from "@material-ui/icons/Category";
import NoSignature from "@material-ui/icons/Clear";
import SingleSignature from "@material-ui/icons/Done";
import DoubleSignature from "@material-ui/icons/DoneAll";
import Manager from "@material-ui/icons/HowToReg";
import ShiftLeader from "@material-ui/icons/People";
import BasicUser from "@material-ui/icons/Person";
import Settings from "@material-ui/icons/Settings";
import ThumbsUpDown from "@material-ui/icons/ThumbsUpDown";
import ContentView from "Components/ContentView/ContentView";
import ToggleBar from "Components/ToggleBar/ToggleBar";
import ToggleOption from "Components/ToggleBar/ToggleOption/ToggleOption";
import { ScoreType } from "Models/Audit/ScoreType";
import { RoleType } from "Models/Users/RoleType";
import React from "react";
import i18n from "Translations/i18n";
import styles from "./AuditTemplateSettings.scss";

interface IProps {
    selectedRole: string;
    selectedSingleSignatureRequired: boolean;
    selectedDoubleSignatureRequired: boolean;
    selectedScoreType?: string;
    minCustomScoreValue: number;
    maxCustomScoreValue: number;
    auditHasBeenCompleted: boolean;
    onRoleChanged(newValue: RoleType): void;
    onSignatureRequiredChanged(signatureRequired: boolean, doubleSignatureRequired: boolean): void;
    onScoreTypeChanged(newValue: ScoreType): void;
    onScoreSelectionChanged(newMinValue: number, newMaxValue: number): void;
}

interface IState {
    selectedScoreValues: number[];
}

export class AuditTemplateSettings extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            selectedScoreValues: [props.minCustomScoreValue, props.maxCustomScoreValue]
        };

        this.onRoleSelectionChanged = this.onRoleSelectionChanged.bind(this);
        this.onSignatureRequiredChanged = this.onSignatureRequiredChanged.bind(this);
        this.onScoreTypeChanged = this.onScoreTypeChanged.bind(this);
        this.onScoreSelectionChanging = this.onScoreSelectionChanging.bind(this);
        this.onScoreSelectionChanged = this.onScoreSelectionChanged.bind(this);
    }

    public onRoleSelectionChanged(newValue: RoleType) {
        this.props.onRoleChanged(newValue);
    }

    public onSignatureRequiredChanged(newValue: string) {
        const newValues = newValue.split(",");
        this.props.onSignatureRequiredChanged(JSON.parse(newValues[0]), JSON.parse(newValues[1]));
    }

    public onScoreTypeChanged(newValue: ScoreType) {
        this.props.onScoreTypeChanged(newValue);
    }

    public onScoreSelectionChanging(event: any, newValue: number[]) {
        this.setState({
            selectedScoreValues: newValue
        });
    }

    public onScoreSelectionChanged(event: any, newValue: number[]) {
        this.props.onScoreSelectionChanged(newValue[0], newValue[1]);
    }

    public render() {
        return (
            <ContentView>
                <h1><Settings />{i18n.t("audits.settings.title")}</h1>
                <div className={styles.settings}>
                    <div className={styles.table}>
                        <div className={styles.row}>
                            <div className={styles.column}>
                                <span>{i18n.t("audits.settings.role.label")}</span>
                            </div>
                            <div className={styles.column}>
                                <ToggleBar selectedItem={this.props.selectedRole} onChange={this.onRoleSelectionChanged} fullWidth={true}>
                                    <ToggleOption value={RoleType.basic}><BasicUser /> {i18n.t("authentication.roles.basic")}</ToggleOption>
                                    <ToggleOption value={RoleType.shiftleader}><ShiftLeader /> {i18n.t("authentication.roles.shift_leader")}</ToggleOption>
                                    <ToggleOption value={RoleType.manager}><Manager /> {i18n.t("authentication.roles.manager")}</ToggleOption>
                                </ToggleBar>
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.column}>
                                <span>{i18n.t("audits.settings.signature.label")}</span>
                            </div>
                            <div className={styles.column}>
                                <ToggleBar selectedItem={[this.props.selectedSingleSignatureRequired, this.props.selectedDoubleSignatureRequired].toString()} onChange={this.onSignatureRequiredChanged} fullWidth={true}>
                                    <ToggleOption value={[false, false].toString()}><NoSignature /> {i18n.t("audits.settings.signature.none")}</ToggleOption>
                                    <ToggleOption value={[true, false].toString()}><SingleSignature /> {i18n.t("audits.settings.signature.one")}</ToggleOption>
                                    <ToggleOption value={[true, true].toString()}><DoubleSignature /> {i18n.t("audits.settings.signature.two")}</ToggleOption>
                                </ToggleBar>
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.column}>
                                <span>{i18n.t("audits.settings.scoring.label")}</span>
                            </div>
                            <div className={styles.column}>
                                <ToggleBar selectedItem={this.props.selectedScoreType} onChange={this.onScoreTypeChanged} fullWidth={true} disabled={this.props.auditHasBeenCompleted}>
                                    <ToggleOption value={ScoreType.thumbs}><ThumbsUpDown /> {i18n.t("audits.settings.scoring.thumbs")}</ToggleOption>
                                    <ToggleOption value={ScoreType.score}><Custom /> {i18n.t("audits.settings.scoring.custom")}</ToggleOption>
                                </ToggleBar>
                            </div>
                        </div>
                        {((this.props.selectedScoreType === ScoreType.score)
                            && (<div className={styles.row} >
                                <div className={styles.column} />
                                <div className={styles.column} >
                                    <Slider 
                                        className={styles.slider} 
                                        value={this.state.selectedScoreValues} 
                                        onChange={this.onScoreSelectionChanging} 
                                        onChangeCommitted={this.onScoreSelectionChanged} 
                                        min={0} max={10} 
                                        valueLabelDisplay="on" 
                                        aria-labelledby="range-slider" 
                                        marks={[{value: 0, label: "0"}, {value: 10, label: "10"}]}
                                        step={1}
                                        disabled={this.props.auditHasBeenCompleted} />
                                </div>
                            </div>
                            ))
                        }
                    </div>
                </div>
            </ContentView>
        );
    }
}

export default AuditTemplateSettings;


// WEBPACK FOOTER //
// ./src/Components/Pages/AuditTemplateDetailView/AuditTemplateSettings/AuditTemplateSettings.tsx